// extracted by mini-css-extract-plugin
module.exports = {"box":"IntentionDivider_box_OEhCa"};